// import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import authConfig from './authConfig'
import AuthService from './authService'

const auth = new AuthService(axios, authConfig)

export default auth
